module.exports = __webpack_public_path__ + "img/keyboard_O.1f3c528e.png";